const state = {
    trip_search_query: {},
    contact: {
        address: {
            country_code: ''
        }
    },
    vehicles: null,
    checkout_token: ''
}

// getters
const getters = {
    trip_search_query: (state) => {
        return state.trip_search_query;
    },
    contact: (state) => {
        return state.contact;
    },
    vehicles: (state) => {
        return state.vehicles;
    },
    checkout_token: (state) => {
        return state.checkout_token;
    }
}

// actions
const actions = {
}

// mutations
const mutations = {
    set_trip_search_query(state, value) {
        state.trip_search_query = value;
    },
    set_contact(state, value) {
        state.contact = value;
    },
    set_vehicles(state, value) {
        state.vehicles = value;
    },
    set_checkout_token(state, value) {
        state.checkout_token = value;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
